// Uncomment to test if any styles leaked to Microfrontend
// import './App.css';

import { useAuth0 } from '@auth0/auth0-react';
import { useEffect } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router';

import { HostLayout } from './HostLayout';
import { MountAsWidget } from './MountAsWidget';
import { MountToContainer } from './MountToContainer';
import ProtectedRoute from './ProtectedRoute';

const App = () => {
  const { isAuthenticated, isLoading, getIdTokenClaims } = useAuth0();

  // Store and refresh Auth0 token in localStorage and handle redirect
  useEffect(() => {
    let refreshInterval: NodeJS.Timeout | null = null;

    const storeAuth0Token = async () => {
      if (isAuthenticated && !isLoading) {
        try {
          // Get the ID token from Auth0
          const claims = await getIdTokenClaims();
          if (claims && claims.__raw) {
            // Store the raw JWT token in localStorage
            localStorage.setItem('auth0Token', claims.__raw);

            // Get token expiration time from claims
            if (claims.exp) {
              const expirationTime = claims.exp * 1000; // Convert to milliseconds
              const currentTime = Date.now();
              const timeUntilExpiry = expirationTime - currentTime;

              // If token is valid for more than 5 minutes, set refresh to occur 5 minutes before expiry
              if (timeUntilExpiry > 5 * 60 * 1000) {
                const refreshTime = timeUntilExpiry - 5 * 60 * 1000;

                // Clear existing interval if any
                if (refreshInterval) {
                  clearTimeout(refreshInterval);
                }

                // Set timeout to refresh token before it expires
                refreshInterval = setTimeout(storeAuth0Token, refreshTime);
              }
            }
          }
        } catch (error) {
          // Authentication error handling
          console.error('Failed to get Auth0 token:', error); //eslint-disable-line
        }
      }
    };

    storeAuth0Token();

    // Handle redirect to home page after successful authentication
    const params = new URLSearchParams(window.location.search);
    if (params.has('code') && params.has('state') && isAuthenticated && !isLoading) {
      window.history.replaceState({}, document.title, '/');
    }

    // Cleanup function to clear interval when component unmounts
    return () => {
      if (refreshInterval) {
        clearTimeout(refreshInterval);
      }
    };
  }, [isAuthenticated, isLoading, getIdTokenClaims]);

  return (
    <BrowserRouter>
      <Routes>
        <Route element={<ProtectedRoute />}>
          <Route element={<HostLayout />}>
            <Route path='/' element={<MountAsWidget />} />
            <Route path='/fixed' element={<MountToContainer />} />
          </Route>
        </Route>
        <Route path='/login' element={<div>Redirecting to login...</div>} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
